import React from 'react'
import classNames from 'classnames'
import Chevron from 'media/select-arrow-black.svg?svgr-webpack'

type Props = {
  children: React.ReactNode
  use?: React.ElementType
  arrow?: boolean
  open?: boolean
  primary?: boolean
  className?: string
  disabled?: boolean
  // use: Link props
  to?: string
  // use: <a /> props
  href?: string
} & React.HTMLAttributes<HTMLButtonElement> &
  React.HTMLAttributes<HTMLLinkElement>

export default function MoreButton({
  use: Component = 'button',
  arrow = false,
  open = false,
  primary = false,
  children,
  className,
  disabled,
  to,
  ...rest
}: Props) {
  return (
    <Component
      className={classNames(
        'inline-block',
        'border-1 rounded-full',
        'pt-8 pb-6 px-32',
        'type-upper-fat leading-default',
        'cursor-pointer',
        'transition',
        primary
          ? 'border-Brand bg-Brand text-TypeConstant shadow-elevated'
          : 'border-Border text-Type',
        disabled
          ? 'cursor-not-allowed'
          : primary
          ? 'hover:bg-BrandDark'
          : 'hover:border-grey',
        className
      )}
      style={{
        minWidth: 230,
      }}
      to={to}
      {...rest}
    >
      {children}
      {arrow && (
        <>
          <span className="sr-only">{open ? ' (show)' : ' (hide)'}</span>
          <span
            aria-hidden="true"
            className="ml-8 relative"
            style={{ bottom: 2 }}
          >
            <span
              className={classNames(
                'inline-block transform transition',
                open && 'rotate-180'
              )}
              style={{ lineHeight: 0 }}
            >
              <Chevron width="10" />
            </span>
          </span>
        </>
      )}
    </Component>
  )
}
